const initAuthDetails = (state, payload) => {
  state.token = payload.token;
  state.isAuthenticated = payload.isAuthenticated;
  state.user = payload.user;
};

export default {
  initAuthDetails,
};
